import { render, staticRenderFns } from "./BaseEditor.vue?vue&type=template&id=5f275226"
import script from "./BaseEditor.vue?vue&type=script&lang=js"
export * from "./BaseEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports